import IMaterial from '@/interfaces/material';
import PrescriptionModel from '@/models/prescription-model';
import { IdNomeDTO } from './base-dto';

interface IProduct {
  id: string;
  codigo: string;
  descricao: string;
  subgrupo: any;
  quantidadeReferencia?: number;
  unidades?: any[];
  insumos?: any[];
  totalInsumos?: any[];
  ativo?: boolean;
  isAgua?: boolean;
  disponibilizarNaPrescricao?: boolean;
  divisivelBolsas?: boolean;
  visibilidade?: string;
  coloracao?: string;
  concentracao?: number;
  osmolaridade?: number;
  densidade?: number;
  kcalGrama?: number;
  grama?: number;
  mmol?: number;
  meq?: number;
  ui?: number;
  usoPacienteAdulto?: boolean;
  usoPacienteNeonato?: boolean;
  usoPacientePediatrico?: boolean;
  urlEducativo?: string;
  caloria?: ICalorie;
  empresa: number;
  permiteAltAutomatica: boolean;
  isChangeable?: boolean;
  permitePesoCalorico: boolean;
}

interface ICalorie {
  id: string;
  descricao: string;
  kcalGrama?: number;
}

export interface IProductMaterial {
  id?: string;
  insumo: IMaterial;
  proporcaoInsumoProduto: number;
  quantidade: number;
}

export class ListaProdutosParm {
  produtos: UnidadeMedidaProdCalcParm[];

  public loadProdutos(produtos: any[]) {   
    this.produtos = [];
    produtos.forEach((prod) => {
      let prodParm: UnidadeMedidaProdCalcParm = new UnidadeMedidaProdCalcParm();
      prodParm.idProduto = prod.idProduto;
      if (prod.unidadeMedidasProduto.filter((um) => um.digitado).length) {
        let unidadeMedida = prod.unidadeMedidasProduto.filter((um) => um.digitado)[0];
        prodParm.idUnidadeMedida = unidadeMedida.id;
        prodParm.valor = unidadeMedida.valor;
        this.produtos.push(prodParm);
      }
    });
  }
}

export class UnidadesMedidasProdutosParm extends ListaProdutosParm {
  pesoPaciente: number;
  alturaPaciente: number;
  usarImc: boolean;
  volumeBolsaMl: number;
  volumeDigitadoPorKg: boolean;
  tempoInfusao: number;

  public load(model: PrescriptionModel) {
    super.loadProdutos(model.produtos);
    this.pesoPaciente = model.paciente && model.paciente.peso? Number(model.paciente.peso) : null;
    this.alturaPaciente = model.paciente && model.paciente.altura ? Number(model.paciente.altura) : null;
    this.usarImc = model.paciente && model.paciente.altura ? true : false;
    this.volumeBolsaMl = model.volumeDesejado ? Number(model.volumeDesejado) : null;
    this.volumeDigitadoPorKg = model.volumeDigitadoPorKg;
    if (this.volumeDigitadoPorKg) {
      this.volumeBolsaMl = Number(model.volumeFinalMlKgDia);
    }
    this.tempoInfusao = model.tempoInfusao;
  }
}

export class UnidadesMedidasProdutosCalcParm extends UnidadesMedidasProdutosParm {
  pesoCalorico: number;

  public load(model: PrescriptionModel) {
    super.load(model);
    this.pesoCalorico = model.usoPesoCalorico ? Number(model.paciente.pesoCalorico) : null;
  }
}

export class UnidadesMedidasProdutosPacienteCalcParm extends UnidadesMedidasProdutosParm {
  idUnidCliente: Number;
  idPaciente: Number;
  usoPesoCalorico: boolean;
  validarUsoHistorico: boolean;

  public load(model: PrescriptionModel) {
    super.load(model);
    this.idUnidCliente = model.unidade && model.unidade.id ? Number(model.unidade.id) : null;
    this.idPaciente = model.paciente && model.paciente.id ? Number(model.paciente.id) : null;
    this.usoPesoCalorico = model.usoPesoCalorico;
  }
}

export class UnidadeMedidaProdCalcParm {
  idProduto: number;
  idUnidadeMedida: number;
  valor: number;
}

export class MedidasProdutosEnteralCalcParm extends UnidadesMedidasProdutosPacienteCalcParm {
  idEnteral: Number;
  qtdeEnteralMl: Number;
  objetivoCalorico: Number;
  fatorTermogenese: Number;
  fatorSuspensao: Number;
  idTerapia: Number;
  volumeDemaisFluidosMl: Number;
}

export class ConversaoMedidasDTO {
  idProduto: number;
  codProduto: string;
  nomeProduto: string;
  unidades: UnidadeMedidaProdutoDTO[];
  insumos: TotalInsumoDTO[];
  proporcaoEnteral: number;
  proporcaoTermogenese: number;
  usoHistPaciente: ProdutoUsoHistPaciente;
}

export class UnidadeMedidaProdutoDTO {
  id: number;
  nome: string;
  valor: number;
  digitado: boolean;
  valorEnteral: number;
  valorTermogenese: number;  
}

export class ProdutoUsoHistPaciente {
  usoHistPaciente: boolean;
  dataUsoHistPaciente: Date;
  msgUsoHistPaciente: string;
}

export class TotalInsumoDTO {
  idInsumo: number;
  insumo: string;
  quantidade: number;
  unidadeMedida: string;
  quantidadeEnteral: number;
  quantidadeTermogenese: number;
}

export class MedidasProdutosEnteralResult {
  idEnteral: Number;
  nomeEnteral: string;
  qtdeEnteralMl: Number;
  tipoCalculo: IdNomeDTO;

  objetivoCalorico: Number;
  fatorTermogenese: Number;
  fatorSuspensao: Number;

  pesoPacienteUsado: Number;
  objetivoCaloricoPeso: Number;

  ofertaCaloricaNE: Number;
  termogeneseNE: Number;
  ofertaCaloricaEfetivaNE: Number;

  fatorCorrecaoNE: Number;
  fatorCorrecaoNP: Number;

  volumeNE: Number;
  volumeNP: Number;
  volumeFinal: Number;

  suspender: boolean;
  mensagemSuspensao: string;
  medidas: ConversaoMedidasDTO[];
  medidasSemDesconto: ConversaoMedidasDTO[];
}

export class InsumoProdutoParmDTO {
  idInsumo: number;
  quantidade: number;
  quantidadeReferencia: number;
}

export class ProdutoParmDTO {

  id: number;
  codigo: string;
  descricao: string;
  idSubgrupo: number;
  ativo: boolean;

  divisivelBolsas: boolean;
  disponibilizarNaPrescricao: boolean;
  permiteAltAutomatica: boolean;
  visibilidade: string;
  coloracao: string;
  permitePesoCalorico: boolean;

  concentracao: number;
  osmolaridade: number;
  densidade: number;
  grama: number;
  mmol: number;
  meq: number;
  ui: number;
  idCaloria: number;
  kcalGrama: number;

  usoPacienteAdulto: boolean;
  usoPacientePediatrico: boolean;
  usoPacienteNeonato: boolean;

  tipoPacConfigs: ProdutoTipoPacConfigParmDTO[];

  idsUnidadesMedidas: number[];
  insumos: InsumoProdutoParmDTO[];
  
  justifAlteracao: string;
  deleteFile: boolean;
}

export class ProdutoTipoPacConfigParmDTO {
  uso: boolean;
  tipoPaciente: string;
  pesoMin: number;
  pesoMax: number;
  idadeMin: number;
  idadeMinTipo: string;
  idadeMax: number;
  idadeMaxTipo: string;
}

export default IProduct;
export { ICalorie };

